import { Component, OnInit, ViewChild, EventEmitter, Output, HostListener } from '@angular/core';
import { ObjectToSelect } from '../objectToSelect.model';
import { EmployeesRest } from '../../../company/employees/employee.rest';
import { NgForm } from '@angular/forms';
import { ModalComponent } from '../modal/modal.component';
import { NotificationForEmployee } from '../../../absences/absences.model';
import { INgxSelectOption } from 'ngx-select-ex';

@Component({
  selector: 'app-employee-id-selection',
  templateUrl: './employee-id-selection.component.html',
})
export class EmployeeIdSelectionComponent implements OnInit {

  public currentEmployeer: String;
  public employees: ObjectToSelect[];
  public notificationEmployeeId: number;
  private employeesOpen = false;
  private isSaving = false;

  constructor(private rest: EmployeesRest) { }

  @ViewChild('employeeSelectionForm') employeeSelectionForm: NgForm;
  @ViewChild(ModalComponent) public modal: ModalComponent;
  @Output() onSuccess: EventEmitter<{ isSuccess: boolean, selectedEmployeeId: any }> = new EventEmitter<{ isSuccess: boolean, selectedEmployeeId: any }>();

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.modal.modalRoot.isShown === true && this.employeeSelectionForm.valid) {
      this.confirm();
      event.preventDefault();
    }
  }

  ngOnInit() {
    this.modal.title = 'Wybierz pracownika';
  }

  public selectEmployee(employees: ObjectToSelect[], existingEmployeeIds: number[]) {
    this.employees = employees.filter(x => existingEmployeeIds.every(employeeId => employeeId !== x.id));
    this.modal.openWithCustomSize({ height: '25vh', width: '450px' });
  }


  public closeModal() {
    this.modal.close();
  }

  private confirm() {
    if (this.isSaving) {
      return;
    }

    this.addNotificationEmployee();
  }

  private addNotificationEmployee() {
    this.onSuccess.emit({ isSuccess: true, selectedEmployeeId: this.notificationEmployeeId });
    this.modal.close();
  }

  private onOpen() {
    this.employeesOpen = true;
  }

  private onClose() {
    this.employeesOpen = false;
  }

  private searchCallback(search: string, item: INgxSelectOption): boolean {
    search = search.toLowerCase();
    return item.data.name.toLowerCase().includes(search) || item.data.guid.toLowerCase().includes(search);
  }
}
